import React from 'react';
import { showModal } from '../../../../styles/js/modals';

const AddTo = ({ modalId, show }) => {
  if (!show) return null;

  return (
    <div className="mb-20 text__black text__fs-16">
      <a
        href=""
        className="text__black"
        data-dismiss="modal"
        id="addTo"
        onClick={(e) => {
          e.preventDefault();
          showModal(`${modalId}addToPlaylistAndCollection`);
        }}
      >
        <i className="fa fa-plus text__turquoise-medium text__fs-20 mr-4" /> Add
        to...
      </a>
    </div>
  );
};

export default AddTo;
